import { FormControl, Grid, MenuItem, Select } from "@mui/material";
import React from "react";
import styles from "../../styles.module.scss";

import Button from "../../../../common/Button";

import { responseStatus, userStatus } from "../../../../../constants/user";
import BillUploadButton from "./BillUploadButton";
import { IBillSummary } from ".";

type Props = {
  patient: any;
  billSummary: IBillSummary;
  setBillSummary: React.Dispatch<React.SetStateAction<IBillSummary>>;
  handleBillSummary: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBillUpload: (data: string[]) => void;
  selectedStatus: string;
};

const BillUploadFields = (props: Props) => {
  const {
    patient,
    billSummary,
    setBillSummary,
    handleBillSummary,
    handleBillUpload,
    selectedStatus,
  } = props;
  return (
    <>
      {[userStatus.DISCHARGED, userStatus.LAMA, userStatus.EXPIRED].includes(
        selectedStatus
      ) && (
        <div className={`mg-t-16`}>
          <label className="form-label">
            Upload Bill and discharge summary
          </label>

          <Grid className="align-items-center mg-t-2" container spacing={2}>
            <Grid item xs={12} md={6}>
              <label className="form-label">Bill Number*</label>
              <input
                value={billSummary.billNumber}
                onChange={handleBillSummary}
                type="text"
                className="form-control form-control-light form-control-sm mb-5 "
                name="billNumber"
                placeholder="Bill Number"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <label className="form-label">Bill Amount*</label>
              <input
                value={billSummary.billAmount}
                onChange={handleBillSummary}
                type="number"
                className="form-control form-control-light form-control-sm mb-5 "
                name="billAmount"
                placeholder="Bill Amount"
              />
            </Grid>
          </Grid>
          <BillUploadButton name="billDocuments" callBack={handleBillUpload} />
        </div>
      )}

      {[userStatus.CLOSED].includes(selectedStatus) && (
        <div className={`mg-t-16`}>

          <Grid className="align-items-center mg-t-2" container spacing={2}>
            <Grid item xs={12} md={6}>
              <label className="form-label">Closed Bill Amount*</label>
              <input
                value={billSummary.closedBillAmount}
                onChange={handleBillSummary}
                type="number"
                className="form-control form-control-light form-control-sm mb-5 "
                name="closedBillAmount"
                placeholder="Closed Bill Amount"
              />
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
};

export default BillUploadFields;
